/* @flow */
import * as React from 'react';
import { reduce } from 'lodash';

import BatchRoleCorrectionModalCommon from './BatchRoleCorrectionModalCommon';
import GroupMembership from 'entities/GroupMembership';
import User from 'entities/User';

export type Props = {
  organization: {
    +id: Backbone$Id,
  },
  groupMemberships: GroupMembership[],
};

export default function BatchRoleCorrectionModalForGroupMemberships(props: Props) {
  const { organization, groupMemberships, ...others } = props;

  const uData = reduce(
    groupMemberships,
    (arr, groupMember) => {
      const orgView = groupMember.getOrgAffiliationView();
      if (orgView) {
        arr.push({
          // this is jank as GroupMembership.getUser returns Subscriber
          // but... that's how it was before 0.98.0 flow fix
          user: ((groupMember.getUser(): any): User),
          orgAffiliationView: orgView,
        });
      }
      return arr;
    },
    []
  );

  return (
    <BatchRoleCorrectionModalCommon
      {...others}
      organizationId={parseInt(organization.id, 10)}
      userData={uData}
    />
  );
}
